import PortfolioContent from './PortfolioContent';

export default PortfolioContent;
